export class TypeFile {
  public static readonly EXECUTABLE = 1;
  public static readonly COMPRESSED = 2;
}
